import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import banner from '../../images/login-banner.png';
import styles from './index.module.css';

function ErrorPage() {
  const error = useRouteError();

  const is404 = isRouteErrorResponse(error) && error.status === 404;
  const code = isRouteErrorResponse(error) ? error.status : '!';
  const message = is404
    ? "We couldn't find the page you were looking for."
    : "Something went wrong. Please try again.";

  return (
    <div className={styles.page}>
      <div className={styles.brandBar}>
        <img src={banner} alt="Joyya" className={styles.brandLogo} />
      </div>
      <div className={styles.content}>
        <div className={styles.card}>
          <p className={styles.code}>
            <span className={styles.codeAccent}>{code}</span>
          </p>
          <h1 className={styles.title}>{is404 ? 'Page not found' : 'Unexpected error'}</h1>
          <p className={styles.message}>{message}</p>
          <Link to="/" className={styles.homeLink}>Go home</Link>
        </div>
      </div>
    </div>
  );
}

export { ErrorPage };
